import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const CardItemPaymentRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),

  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
    flexDirection: 'column'
  }
}));

export const CardItemPayment = styled(Box)(({ theme }) => ({
  borderRadius: '8px',
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  backgroundColor: 'transparent',
  boxShadow: 'none',
  padding: theme.spacing(3)
}));
